import {useState, forwardRef, memo} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import ImageIcon from '@mui/icons-material/ImageOutlined'


const styles = {
  root: css`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f0f0f0;
    padding: 30%;
  `,
  icon: css`
    height: 100%;
    width: 100%;
    color: #979797;
    max-width: 80px;
  `
}


const DefaultPlaceholder = (props) => (
  <div css={styles.root} {...props}>
    <ImageIcon css={styles.icon} />
  </div>
)



const Image = forwardRef(({src, alt, placeholder, loading = 'auto', ...props}, ref) => {
  const [error, setError] = useState(false)
  const [loaded, setLoaded] = useState(false)


  const handleError = (e) => {
    setError(true)
    if (props.onError) {
      props.onError(e)
    }
  }


  const handleLoad = (e) => {
    setLoaded(true)
    if (props.onLoad) {
      props.onLoad(e)
    }
  }


  if (!src || error) {
    return placeholder ? placeholder : <DefaultPlaceholder {...props} />
  }


  return (
    <img
      src={src}
      alt={alt}
      ref={ref}
      css={css`
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: ${loaded ? 1 : 0};
        transition: opacity 0.3s ease-in;
      `}
      loading={loading}
      onLoad={handleLoad}
      onError={handleError}
      {...props}
    />
  )
})


export default memo(Image)


